import { Alert, Link } from 'ui-components-web'
import useAlert from '../hooks/useAlert'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

const withCustomAlert = (Child) => {
  return function CustomAlert({ ...props }) {
    const { alert, setAlert, resetAlert } = useAlert()
    const handleShowAlert = ({
      title,
      body,
      onConfirm,
      customButtons,
      showButtons,
      titleStyle,
      containerTestId,
      cancelBtnTestId,
      okBtnTestId,
      titleTestId,
    }) => {
      setAlert({
        visible: true,
        title: '',
        type: 'custom',
        alertStyle: { display: 'block' },
        body: (
          <div className="[&>h2]:hidden" data-testid={containerTestId}>
            <h1
              className={classNames('typography-h5 text-primary-800 mb-5 text-xl', titleStyle)}
              data-testid={titleTestId}
            >
              {title}
            </h1>
            {body}
            {showButtons ? (
              <div className="mt-5">
                <Link onClick={resetAlert} tabIndex={0} role="button" underline="none" data-testid={cancelBtnTestId}>
                  Cancel
                </Link>
                <Link
                  tabIndex={0}
                  onClick={onConfirm || resetAlert}
                  underline="none"
                  color={'primary'}
                  role="button"
                  className={'ml-10 font-semibold'}
                  data-testid={okBtnTestId}
                >
                  OK
                </Link>
              </div>
            ) : (
              customButtons
            )}
          </div>
        ),
        custom: true,
        showCancel: false,
        showConfirm: false,
        onCancel: resetAlert,
      })
    }

    return (
      <>
        <Child {...props} showAlert={handleShowAlert} resetAlert={resetAlert}></Child>
        <Alert {...alert} isAlert={alert.visible} />
      </>
    )
  }
}

export default withCustomAlert
